import { createStore } from "vuex";
import VuexPersister from "vuex-persister";
const vuexPersister = new VuexPersister({
  // ...your options
});
import auth from "./auth";
import sport from "./sport";
import points from "./points";
// tennis
import sidebar from "./tennis/sidebar";
import order from "./tennis/order";
import extraaddon from "./tennis/extraaddon";
import rule from "./tennis/rule";
// padel
import padel_sidebar from "./padel/sidebar";
import padel_order from "./padel/order";
import padel_extraaddon from "./padel/extraaddon";
import padel_rule from "./padel/rule";
import location from "./location";

// default nya di localStorage
const store = createStore({
  plugins: [vuexPersister.persist],
  modules: {
    auth,
    sport,
    points,
    sidebar,
    order,
    extraaddon,
    rule,
    location,
    padel_sidebar,
    padel_order,
    padel_extraaddon,
    padel_rule,
  },
});

export default store;
